"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from '@/components/common/Link';
export default function TheLegalTeam() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const cultivators = [{
    name: "Martin Birenbaum",
    role: "FOUNDING MEMBER",
    bio: "Specializing in multi-generational wealth preservation and complex estate structures for Florida's high-net-worth families.",
    credentials: "\n",
    image: "https://legacywealthlegal.com/wp-content/uploads/2026/06/MB-Profile-Picture.png?v=zvdkxpkvy37",
    srcset: "https://legacywealthlegal.com/wp-content/uploads/2026/06/image_9e31ba54.png?v=uha2jp5k9oe",
    sizes: "https://legacywealthlegal.com/wp-content/uploads/2026/06/image_9e31ba54.png?v=ztpldy9hcc"
  }, {
    name: "David Birenbaum",
    role: "MANAGING DIRECTOR",
    bio: "Expert in revocable and irrevocable trust design, focusing on privacy maintenance and court avoidance for private estates.",
    credentials: "\n",
    image: "https://legacywealthlegal.com/wp-content/uploads/2026/06/image_9e31ba54.png?v=0xg87amste6b",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/IMG_003031-1-scaled.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/IMG_003031-1-scaled.png"
  }, {
    name: "\n",
    role: "\n",
    bio: "Architect of robust legal frameworks designed to shield family wealth from creditors and litigation using Florida-specific statutes.",
    credentials: "\n",
    image: "https://legacywealthlegal.com/wp-content/uploads/2026/06/cropped-lwl-logo-2-1.png?v=d3y8k8pz90s",
    srcset: "https://legacywealthlegal.com/wp-content/uploads/2026/06/cropped-lwl-logo-2-1.png?v=5phbb0nlii",
    sizes: "https://legacywealthlegal.com/wp-content/uploads/2026/06/cropped-lwl-logo-2-1.png?v=am8cod5d0zk"
  }, {
    name: "\n",
    role: "\n",
    bio: "Dedicated to protecting the next generation through comprehensive healthcare directives and specialized minor trust planning.",
    credentials: "\n",
    image: "https://legacywealthlegal.com/wp-content/uploads/2026/06/cropped-lwl-logo-2-1.png?v=w3gb1ybjry9",
    srcset: "https://legacywealthlegal.com/wp-content/uploads/2026/06/cropped-lwl-logo-2-1.png?v=i3x6lo0wr9d",
    sizes: "https://legacywealthlegal.com/wp-content/uploads/2026/06/cropped-lwl-logo-2-1.png?v=53p42huhlhg"
  }];
  return <section data-section-id="2920" id="the-legal-team" className="bg-background text-foreground pt-0 pb-24 md:pt-0 md:pb-32 lg:pt-0 lg:pb-40 px-6 md:px-12 lg:px-20 overflow-hidden -mt-54 md:-mt-66 lg:-mt-78">
      <div className="max-w-7xl">
        {}
        <div ref={headerRef} className={`mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="flex items-center gap-4 mb-10"><br /><span className="font-mono text-xs tracking-[0.2em] text-primary" data-ast-id="f:/src/pages/FirmStory/sections/TheLegalTeam.tsx|sig:vdu7r7" data-ast-start="3126" data-ast-end="3321"><br /></span><br /></div>
          <h2 className="font-default font-semibold text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-foreground max-w-5xl">
            The architects<span className="text-secondary">/</span>
            <br />
            of family<span className="text-secondary">/</span>
            <br />
            and <em className="italic text-primary font-medium">legacy.</em>
          </h2>
        </div>

        {}
        <div ref={gridRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-16 md:gap-y-20">
          {cultivators.map((person, i) => <article data-index={i} key={i} className={`group flex flex-col transition-all duration-1000 ease-out ${i % 2 === 1 ? "lg:mt-12" : ""} ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: gridVisible ? `${i * 120}ms` : "0ms"
        }}>
              {}
              <div className="relative overflow-hidden aspect-[3/4] mb-6 bg-secondary/10 rounded-md shadow-md">
                {}
                <div className="absolute inset-0 z-10 mix-blend-multiply pointer-events-none transition-opacity duration-[600ms] ease-out group-hover:opacity-0" style={{
              background: "linear-gradient(180deg, hsla(215, 45%, 10%, 0.4) 0%, hsla(215, 45%, 10%, 0.9) 100%)"
            }} />
                {}
                <div className="absolute inset-0 z-20 pointer-events-none opacity-[0.12] transition-opacity duration-[600ms] group-hover:opacity-[0.05] mix-blend-overlay" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
            }} />
                {}
                <div className="absolute top-3 left-3 z-30 w-4 h-4 border-l border-t border-primary/60 pointer-events-none" />
                <div className="absolute bottom-3 right-3 z-30 w-4 h-4 border-r border-b border-primary/60 pointer-events-none" />

                {}
                <div className="absolute bottom-4 right-4 z-30 font-mono text-[10px] tracking-widest text-white/70">
                  0{i + 1} / 0{cultivators.length}
                </div>

                {i === 0 ? <Link to="https://legacywealthlegal.com/martin-birenbaum-biography/">
                    <img src={person.image} data-wvc-srcset={person.srcset} data-wvc-sizes={person.sizes} alt={person.name} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.05] grayscale hover:grayscale-0" />
                  </Link> : i === 1 ? <Link to="https://legacywealthlegal.com/david-birenbaum-biography/">
                    <img src={person.image} data-wvc-srcset={person.srcset} data-wvc-sizes={person.sizes} alt={person.name} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.05] grayscale hover:grayscale-0" />
                  </Link> : <img src={person.image} data-wvc-srcset={person.srcset} data-wvc-sizes={person.sizes} alt={person.name} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-[1.05] grayscale hover:grayscale-0" />}
              </div>

              {}
              <div className="flex items-center gap-3 mb-4">
                <div className="w-1.5 h-1.5 bg-primary transition-all duration-500 group-hover:w-6" />
                <span className="font-mono text-[11px] tracking-[0.18em] text-primary uppercase">
                  {person.role}
                </span>
              </div>

              {}
              <h3 className="font-default font-semibold text-[24px] leading-tight text-foreground mb-4 tracking-tight">
                {person.name}
              </h3>

              {}
              <p className="text-[14px] leading-relaxed text-secondary-foreground mb-6 font-default">
                {person.bio}
              </p>

              {}
              <div className="h-px w-full bg-border mb-4 transition-colors duration-500 group-hover:bg-primary" />

              {}
              <p className="font-mono text-[10px] tracking-[0.12em] text-muted-foreground leading-relaxed uppercase">
                {person.credentials}
              </p>
            </article>)}
        </div>

        {}
        <div ref={footerRef} className={`mt-24 md:mt-32 flex flex-col items-center transition-all duration-1000 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="h-px w-16 bg-primary mb-10" />
          <p className="font-default italic font-light text-2xl md:text-[28px] leading-snug text-foreground text-center max-w-3xl tracking-tight">
            A collective of legal minds dedicated to the preservation of Florida's most significant family legacies.
          </p>
          <div className="mt-10 font-mono text-[10px] tracking-[0.2em] text-secondary uppercase"><br /></div>
        </div>
      </div>
    </section>;
}